export const TAGS = {
  PAYOUT_LIST: 'payoutList',
  SINGLE_PAYOUT: 'payout',
};
